import React from "react";
import { Button, FieldWrap, Select, TextField, Notice, PageHeader, Panel, PanelContent } from '@deque/cauldron-react'

import "./VerificationSearch.scss";
import { VerificationGetRequest } from "../../models";

type VerificationSearchProps = {
    lastName: string,
    LastNameUpdated: (value: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    firstName: string,
    FirstNameUpdated: (value: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    middleInitial: string,
    MiddleInitialUpdated: (value: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    birthMonth: string,
    BirthMonthUpdated: (event: React.ChangeEvent<HTMLSelectElement>) => void,
    birthDay: string,
    BirthDayUpdated: (event: React.ChangeEvent<HTMLSelectElement>) => void,
    birthYear: string,
    birthYearUpdated: (value: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,

    SubmitSearch: (request: VerificationGetRequest) => void,
};

export const VerificationSearch = (props: VerificationSearchProps) => {
    const disableSubmit = (): boolean => {
        return !(props.lastName && props.lastName.trim().length > 0
            && props.firstName && props.firstName.trim().length > 0
            && props.birthMonth && props.birthMonth.length > 0
            && props.birthDay && props.birthDay.length > 0);
    }

    const birthMonthOptions = [
        { key: '', value: '', label: 'Select' },
        { key: '1', value: '1 - January' },
        { key: '2', value: '2 - February' },
        { key: '3', value: '3 - March' },
        { key: '4', value: '4 - April' },
        { key: '5', value: '5 - May' },
        { key: '6', value: '6 - June' },
        { key: '7', value: '7 - July' },
        { key: '8', value: '8 - August' },
        { key: '9', value: '9 - September' },
        { key: '10', value: '10 - October' },
        { key: '11', value: '11 - November' },
        { key: '12', value: '12 - December' },
    ];

    const dayOfBirthOptions = [
        { key: '', value: '', label: 'Select' },
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '3' },
        { key: '4', value: '4' },
        { key: '5', value: '5' },
        { key: '6', value: '6' },
        { key: '7', value: '7' },
        { key: '8', value: '8' },
        { key: '9', value: '9' },
        { key: '10', value: '10' },
        { key: '11', value: '11' },
        { key: '12', value: '12' },
        { key: '13', value: '13' },
        { key: '14', value: '14' },
        { key: '15', value: '15' },
        { key: '16', value: '16' },
        { key: '17', value: '17' },
        { key: '18', value: '18' },
        { key: '19', value: '19' },
        { key: '20', value: '20' },
        { key: '21', value: '21' },
        { key: '22', value: '22' },
        { key: '23', value: '23' },
        { key: '24', value: '24' },
        { key: '25', value: '25' },
        { key: '26', value: '26' },
        { key: '27', value: '27' },
        { key: '28', value: '28' },
        { key: '29', value: '29' },
        { key: '30', value: '30' },
        { key: '31', value: '31' },
    ];

    return (<>
            <PageHeader style={{ paddingBottom: '32px' }} heading="Welcome to the Directory Verification Page for the University of California at Santa Barbara" />
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px' }}>
                <div style={{ flex: 1, padding: '10px', minWidth: '350px' }}> 
                    <div style={{paddingBottom: '16px', fontSize: '18px'}}>Here you can verify Directory Information about UCSB students such as:
                    <ul className="ulPadding">
                        <li>Degrees Awarded</li>
                        <li>Dates of Attendance</li>
                        <li>Local and "Permanent" Addresses</li>
                    </ul>
                    <br/>
                    These items are considered by the Family Educational Rights and Privacy Act ("FERPA") to be Directory Information and therefore releasable at the school's discretion.
                    </div>
                    <Notice type="caution" title="Attention">
                        There are at least three reasons why information about a student, even though correct, might still not be available through this system:
                        <ul className="ulPadding">
                            <li>If the student has not received a degree or attended UCSB more recently than 1990.</li>
                            <li>If the student has changed their name or other identifying information.</li>
                            <li>If the student has requested a "FERPA block".</li>
                        </ul>
                        <br />
                        If one of these possibilities may apply to your query, and the information you
                        seek is not available through this web site, you will need to order a Verification Transcript.
                    </Notice>
                </div>
                <div style={{ flex: 1, padding: '10px' }}>
                    <FieldWrap>
                        <TextField label="Last Name" id="lastName" type="text" value={props.lastName} required onChange={props.LastNameUpdated} />
                        <TextField label="First Name" type="text" id="firstName" value={props.firstName} required onChange={props.FirstNameUpdated} />
                        <TextField label="Middle Initial" type="text" id="middleInitial" value={props.middleInitial} onChange={props.MiddleInitialUpdated} />
                        <Select label="Month of Birth" value={props.birthMonth} id="birthMonth" onChange={props.BirthMonthUpdated} options={birthMonthOptions} required />
                        <Select label="Day of Birth" id="birthDay" value={props.birthDay} onChange={props.BirthDayUpdated} options={dayOfBirthOptions} required />
                        <TextField label="" style={{display: 'none'}} tabIndex={-1} id="birthYear" type="text" value={props.birthYear} onChange={props.birthYearUpdated} />
                        <Button type="submit" disabled={disableSubmit()} onClick={()=>{ props.SubmitSearch({firstName: props.firstName, lastName: props.lastName, birthDay: parseInt(props.birthDay), birthMonth: parseInt(props.birthMonth), middleInitial: props.middleInitial, birthYear: props.birthYear })}}>Submit</Button>
                    </FieldWrap>
                </div>
            </div>
    </>);
};
export default VerificationSearch;